import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import InfoIcon from '@/images/Info.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';

const Header = styled.thead`
    display: flex;
    width: 100%;
    height: 52px;
    padding: 16px 20px;
    border-bottom: 1px solid ${theme.colors.black[300]};
    background-color: ${theme.colors.black[50]};
`;

const Column = styled.th<{ grow?: number; minWidth?: number }>`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    text-align: left;
    color: ${theme.colors.black[700]};
    font-size: 14px;
    font-weight: 400;
    padding: 0;

    ${({ grow }) => grow && `flex: ${grow};`}
    ${({ minWidth }) => minWidth && `min-width: ${minWidth}px;`}
`;

export const styles = {
    tooltip: {
        sx: {
            backgroundColor: '#FFF !important',
            color: theme.colors.secondary[900],
            boxShadow:
                '5.3px 13.3px 18.8px -1.2px rgba(187, 187, 187, 0.29), 2.4px 6.1px 8.6px -0.8px rgba(187, 187, 187, 0.23), 1.1px 2.8px 3.9px -0.4px rgba(187, 187, 187, 0.17), 0.3px 0.8px 1.1px 0px rgba(187, 187, 187, 0.12)',
            padding: '16px',
            borderRadius: '8px',
        },
    },
};

export interface InsightsColumn {
    label: string;
    icon?: string;
    tooltip?: string;
    grow?: number;
    minWidth?: number;
}

interface Props {
    columns: InsightsColumn[];
}

export const TableColumnsHeader = ({ columns }: Props) => {
    return (
        <Header>
            {columns.map(column => (
                <Column key={column.label} grow={column.grow} minWidth={column.minWidth}>
                    {column.icon && <MaskedIcon src={column.icon} size="16px" />}
                    {column.label}
                    {column.tooltip && (
                        <Tooltip
                            title={column.tooltip}
                            slotProps={{
                                tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } },
                            }}>
                            <MaskedIcon src={InfoIcon} size="12px" />
                        </Tooltip>
                    )}
                </Column>
            ))}
        </Header>
    );
};
